var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "935.000000pt",
    height: "932.000000pt",
    viewBox: "0 0 935.000000 932.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,932.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4275 9280 c-1029 -91 -1942 -479 -2700 -1151 -1130 -1000 -1696 -2511 -1505 -4016 92 -716 347 -1394 751 -1993 122 -182 314 -422 452 -565 l106 -110 1 3248 0 3247 3253 0 3252 1 -96 93 c-307 298 -692 568 -1094 769 -495 248 -996 396 -1565 463 -158 18 -701 27 -855 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7910 7685 c-1 -233 -2 -268 -21 -520 -77 -1047 -447 -2105 -1043 -2985 -816 -1203 -2021 -2094 -3381 -2499 -610 -181 -1146 -260 -1770 -262 -151 -1 -275 -4 -275 -8 0 -12 168 -171 270 -257 751 -629 1628 -986 2621 -1065 184 -15 639 -6 819 16 739 88 1396 325 2005 723 269 175 496 365 771 643 203 206 291 307 426 486 788 1043 1087 2389 817 3678 -100 477 -295 979 -539 1385 -163 272 -396 580 -593 785 l-106 110 -1 -230z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05b4ba1f89c33903b9cb5b21e4cd0914.svg";
export { ForwardRef as ReactComponent };